import { render, staticRenderFns } from "./summary.vue?vue&type=template&id=43d680e2&scoped=true"
import script from "./summary.vue?vue&type=script&lang=js"
export * from "./summary.vue?vue&type=script&lang=js"
import style0 from "./summary.vue?vue&type=style&index=0&id=43d680e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d680e2",
  null
  
)

export default component.exports